angular.module('quantixApp').controller('htmltreegridController',
		htmltreegridController);

htmltreegridController.$inject = [ '$scope', 'Principal', '$state',
		'AdvanceSearchService', '$location', 'ivhTreeviewMgr',
		'ivhTreeviewBfs', 'ivhTreeviewOptions', 'GenericService', '$rootScope',
		'$timeout', '$http' ];

function htmltreegridController($scope, Principal, $state,
		AdvanceSearchService, $location, ivhTreeviewMgr, ivhTreeviewBfs,
		ivhTreeviewOptions, GenericService, $rootScope, $timeout, $http) {

	$scope.peerGroup1IndustryGridKeys = [];

	$scope.disablelevelind = function(cell, data) {
		return data.children.length == 0;
	}

	$scope.disablecellind = function(cell, data) {
		return (cell.getLevel().getNestDepth() != 5);
	}

	$scope.setselectedobjs = function() {
		var industryobj = [];

		if (indgri != null && indgri != "") {
			peerGroup1IndustryGridKeys = indgri.getSelectedObjects();

			ivhTreeviewBfs(peerGroup1IndustryGridKeys, opts, function(node) {
				if ($scope.type == 'Industry') {
					if (node.children.length == 0) {
						if (industryobj.indexOf(node) == -1) {
							industryobj.push(node);
						}
					}
				}

			});
		}
		return industryobj;

	}
	$scope.setselectedkeys = function() {
		var industryids = [];

		if (indgri != null && indgri != "") {
			peerGroup1IndustryGridKeys = indgri.getSelectedObjects();

			ivhTreeviewBfs(peerGroup1IndustryGridKeys, opts, function(node) {
				if ($scope.type == 'Industry' || $scope.type == 'Product') {
					if (node.children.length == 0) {
						if (industryids.indexOf(node.id) == -1) {
							industryids.push(node.id);
						}
					}
				}

				if ($scope.type == 'Location') {
					if (!node.children) {
						if (industryids.indexOf(node.id) == -1) {
							industryids.push(node.id);
						}
					}
				}

			});
		}

		return industryids.toString();

	}
	$scope.setselectedkeysstring = function() {

		var industriesNames = '';
		if ($scope.industryall) {
			industriesNames = 'All Industries Selected';
		} else {
			var selectedIndustrieNames = [];
			angular.forEach($scope.selectedIndustriesForDB,
					function(value, key) {
						selectedIndustrieNames.push(value);
					});
			industriesNames = selectedIndustrieNames.toString();
			//}
		}
		return industriesNames;

	}

	$scope.filterData = {};

	var opts = ivhTreeviewOptions(), isExpanded = opts.expandedAttribute;
	$scope.viewTreeIndustry = false;

	$scope.gettooltipforIndustry = function(item, column) {
		var html = "<label title='" + item.label + "'>" + item.label
				+ "</label>"
		return html;
	};

	$scope.sampleIndustrydatadir = JSON.parse($scope.industrydata);

	$scope.indbuttonid = 'industryButton' + $scope.uniqueid;

	$scope.gridOptionsSec = {
		dataProvider : $scope.sampleIndustrydatadir,
		delegate : $scope
	};

	$rootScope.$on('getdatafor' + $scope.uniqueid, function(event, data) {

		//	alert("broadcast from "+$scope.uniqueid);
		$scope.selectedindustry = $scope.setselectedkeys();
		$scope.setvaluesind({
			ids : $scope.selectedindustry
		});
		$scope.setnameind({
			ids : $scope.setselectedkeysstring()
		});
		$scope.selectedindustryobj = $scope.setselectedobjs();
		$scope.setindobj({
			indobj : $scope.selectedindustryobj
		});
		//setnameind
	});
	//alert('loaddatafor'+$scope.uniqueid);
	$rootScope
			.$on(
					'loaddatafor',
					function(event, data) {
						//alert("in dir ");
						if (data.id == $scope.uniqueid) {
							indgri.clearSelection();
							indgri.clearAllFilters();
							indgri.collapseAll();

							if (data.selectedvals == 'All selected') {
								$scope.selectAllind(true);
							}
							var peerGroup1IndustryGridKeystemp = data.selectedvals
									.split(",");
							indgri.setSelectedKeys(
									peerGroup1IndustryGridKeystemp, true);
							var arrstr = [];
							$scope.selectedProducts = [];
							ivhTreeviewBfs(
									$scope.sampleIndustrydatadir,
									function(node) {
										for (var i = 0; i < peerGroup1IndustryGridKeystemp.length; i++) {

											if (node.id == peerGroup1IndustryGridKeystemp[i]) {
												$scope.selectedIndustries
														.push(node.label);

												arrstr.push(node.label);
											}
										}
									});

							$scope.badgeStringInd = $scope.selectedIndustries
									.toString();

						}

					});

	var arrayind = new Array();
	var peerGroup1IndustryGrid = '';
	var peerGroup1IndustryGridKeys = null;
	var allKeysInd = [];
	$scope.selectedIndustries = [];
	var indgri = null;
	$scope.badgeStringInd = '';

	$scope.ind = {
		indstatus : false
	};

	var indfiltervaluchanged = false;
	var firstcharind = '';

	$scope.filerPageSortHandle = function(event) {
		setTimeout(function() {
			var filter = event.target.getRootFilter();
			var grid = event.target;
			if (!filter.filterExpressions.length) {
				grid.collapseAll();
				grid.validateNow();
				//	  grid.rebuild();
				indfiltervaluchanged = false;

			}
			if (!indfiltervaluchanged) {
				if (event.cause == "filterChange") {
					if (filter.filterExpressions
							&& filter.filterExpressions.length) {
						firstcharind = filter.filterExpressions[0].expression
						indfiltervaluchanged = true;
						$scope.onGridCreationCompletedIndustry(null);
					}
				}
			}
		}, 1);
	};

	$scope.onDynamicLevelCind = function(event) {
		//alert("dynamic");

		event.level.setEnableFooters(false);

		if (event.level.getNestDepth() > 1) {

			event.level.forcePagerRow = false;
		} else {
			event.level.forcePagerRow = true;
		}
	};

	$scope.onGridCreationCompletedIndustry = function(event) {

		/*kaushal*/
		if (event != null) {
			indgri = event.target;
			if ($scope.selectionmode == 'single') {
				indgri.setSelectionMode("singleRow");
			}
			indgri.enableHeightAutoAdjust = true;
			indgri.validateNow();

		} else {
			if ($scope.selectionmode == 'single') {
				indgri.setSelectionMode("singleRow");
			}
			indgri.enableHeightAutoAdjust = true;
			indgri.clearFilter();
			indgri.expandAll();
			indgri.setFilterValue('label', firstcharind, indgri);
			indgri.validateNow();
		}
	};

	var filterselectall = false;
	//for industry tree
	$scope.selectAllind = function(flag) {
		allKeysInd = [];
		if (flag) {
			$scope.noinddata = false;
			arrayind = [];
			$scope.selectedIndustries = [];
			if (indfiltervaluchanged) {
				filterselectall = true;
				$scope.industryall = false;
			} else {
				filterselectall = false;
				$scope.industryall = true;
			}

			ivhTreeviewBfs($scope.sampleIndustrydatadir, opts, function(node) {

				if (indfiltervaluchanged) {

					if (node.label.toLowerCase().includes(firstcharind)) {
						$scope.selectedIndustries.push(node.label);
						allKeysInd.push(node.id);

						if (node.children.length > 0) {
							ivhTreeviewBfs(node, opts, function(childnode) {
								allKeysInd.push(childnode.id);
							});
						}

					}

				} else {
					allKeysInd.push(node.id);
				}

			});

			$scope.badgeStringInd = $scope.selectedIndustries.toString();

			$timeout(function() {
				indgri.setSelectedKeys(allKeysInd, false);
			}, 100);
		} else {
			arrayind = [];
			$scope.selectedIndustries = [];
			$scope.industryall = false;
			indgri.clearSelection();
			indgri.clearAllFilters();
			//indgri.clearChanges();
			indfiltervaluchanged = false;
			indgri.collapseAll();
			indgri.validateNow();
			//	indgri.rebuild();
			//alert($scope.selectedProducts);
		}
	}
	$scope.ind.indstatus = false;
	$scope.cnt = 0;

	$scope.setIndustryTree = function() {

		$scope.ind.indstatus = true;
		//$scope.showResult = false;

		$scope.gridOptionsSec = {
			dataProvider : $scope.sampleIndustrydatadir,
			delegate : $scope
		};

		if ($scope.cnt == 0) {
			$scope.cnt = 1;
			$timeout(function() {
				var l = document.getElementById('industryButton'
						+ $scope.uniqueid);
				l.click();
			}, 100, false);

		}
	}

	$scope.setbadgesforIndustry = function(evt) {

		/*kaushal*/
		if ($scope.selectionmode == 'single') {

			var grid = evt.target;
			if (evt.level.getNestDepth() == 5) {
				if (evt.isItemSelected) {
					$scope.noinddata = false;
					arrayind = [];
					arrayind.push(evt.item.label);

				} else {
					arrayind.splice(arrayind.indexOf(evt.item.label), 1);
				}

			}

			$timeout(
					function() {

						$scope.selectedIndustries = angular.copy(arrayind);
						$scope.badgeStringInd = $scope.selectedIndustries
								.toString();

						if ($scope.badgeStringInd.length > 30) {
							for (var i = 0; i < $scope.selectedIndustries.length; i++) {
								if ($scope.selectedIndustries[i].length > 10) {
									$scope.selectedIndustries[i] = $scope.selectedIndustries[i]
											.substr(0, 14)
											+ '..';
								}
							}
							$scope.badgeStringInd = $scope.selectedIndustries
									.toString();
						} else {
							$scope.badgeStringInd = $scope.selectedIndustries
									.toString();
						}

					}, 100);

		} else {
			var grid = evt.target;
			if (evt.isItemSelected) {
				$scope.noinddata = false;
				arrayind.push(evt.item.label);

			} else {
				if (arrayind.indexOf(evt.item.label) != -1) {
					arrayind.splice(arrayind.indexOf(evt.item.label), 1);
				} else if ($scope.industryall) {
					$scope.industryall = false;
					arrayind = [];
					arrayind.push("Multiple Industries selected");
				}

				else if (indgri.getSelectedObjects().length > 1) {
					arrayind = [];
					arrayind.push("Multiple Industries selected");
				} else {
					arrayind = [];
				}
			}

			$timeout(
					function() {
						$scope.selectedIndustries = angular.copy(arrayind);
						$scope.badgeStringInd = $scope.selectedIndustries
								.toString();
						$scope.selectedIndustriesForDB = angular.copy(arrayind);
						if ($scope.badgeStringInd.length > 30) {
							for (var i = 0; i < $scope.selectedIndustries.length; i++) {
								if ($scope.selectedIndustries[i].length > 10) {
									$scope.selectedIndustries[i] = $scope.selectedIndustries[i]
											.substr(0, 14)
											+ '..';
								}
							}
							$scope.badgeStringInd = $scope.selectedIndustries
									.toString();
						} else {
							$scope.badgeStringInd = $scope.selectedIndustries
									.toString();
						}
					}, 100);
		}

	}

}